/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Coutdowntimer
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 11Jul2022 craig File created.
 \******************************************************************************/
import React from 'react';
import './countdowntimer.css';
import {useCountdown} from './UseCountdown';
import DateTimeDisplay from './DateTimeDisplay';

export type ExpireDateProp = {
    date: Date;
}

// @ts-ignore
const CountdownTimer = (props) => {
    const [days, hours, minutes] = useCountdown(props.targetDate);

    if (days + hours + minutes <= 0) {
        return <ExpiredNotice/>;
    } else {
        return <ShowCounter
                header={props.header}
                target={props.targetDate}
                days={days}
                hours={hours}
                minutes={minutes}
            />
    }
};

const ExpiredNotice = () => {
    return (
        <div className="expired-notice">
            <p>This team is past the end date, no new comments are allowed</p>
        </div>
    );
};

const ShowCounter = (props) => {
    return (
        <div className="show-counter">
            <div className={"header"}><h3>{props.header}</h3></div>
            <div className="countdown-container">
                <DateTimeDisplay value={props.days} type={'Days'} isDanger={props.days <= 3}/>
                <div className={"vl"} />
                <DateTimeDisplay value={props.hours} type={'Hours'} isDanger={false}/>
                <div className={"vl"} />
                <DateTimeDisplay value={props.minutes} type={'Mins'} isDanger={false}/>
            </div>
            <div className={"footer"}>
                <p>{props.target.toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</p>
            </div>
        </div>
    );
};

export default CountdownTimer;

